import React from "react";
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    overflow: 'hidden',
    padding:'0',
    boxShadow:'none !important',
  },
  image: {
    width: '100%',
    minHeight:'300px ',
    borderRadius: '5%',
    transition: 'transform 0.3s ease-in-out',
  },
}));

const MyCard = ({ title, content }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent sx={{padding:'0', paddingBottom:'0px !important',borderRadius: '5%'}}>
        <Grid container>
            <img
              src="https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSCsst0dRPFsCiRXabE1wc3A4qAyqwFB9F0QD2iYnY_omKQOXZv"
              alt="property_image"
              className={classes.image}
            />
        </Grid>
        <Grid container direction="column">
          <Grid item>
              <Typography variant="subtitle1" fontWeight='bold'>Appartments</Typography>
          </Grid>
          <Grid item>
              <Typography variant="subtitle2">4 listings</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const AreaList = () => {
  const cards = [
    { title: 'Card 1', content: 'Content 1' },
    { title: 'Card 2', content: 'Content 2' },
    { title: 'Card 3', content: 'Content 3' },
    { title: 'Card 4', content: 'Content 4' },

  ];

  return (
    <>
        <Grid sx={{padding:'40px 0'}}>
            <Typography variant="h4">Featured Listings</Typography>
        </Grid>
        <Grid container spacing={3}>
        {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
                <MyCard title={card.title} content={card.content} />
            </Grid>
        ))}
        </Grid>
    </>
  );
}

export default AreaList;
